module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/layout/layout-top-panel-5-c2e625d0e0e478bf4a4dcea25fb2eafe.svg";